<!-- <app-drawer [customClass]="" [visible]="true" (visibleChange)="close()"> -->

<div class="container py-2 background-grey">
  <div class="row justify-content-center border-bottom sticky-top background-grey">
    <h4 *ngIf="step === 1" class="text-center font-weight-bold text-primary mt-2 mb-1">Buy Gift Card</h4>
    <h4 *ngIf="step === 2" class="text-center font-weight-bold text-primary mt-2 mb-1">You are buying</h4>
    <h4 *ngIf="step === 3" class="text-center font-weight-bold text-primary mt-2 mb-1">Checkout</h4>
  </div>
  <div class="row">

    <div class="gift-card-page">
      <div class="card main-card border-0 background-grey">
        <div class="card-body p-0">



          <!-- STEP 1 -->
          <div *ngIf="step === 1" class="p-3 p-md-4 content-area">


            <form [formGroup]="form">
              <!-- Theme -->
              <div class="form-group">
                <label class="font-weight-bold small mb-2">
                  Select the colours and graphic you like
                </label>

                <div class="d-flex flex-wrap mb-3 theme-thumbs">
                  <div *ngFor="let theme of themes" class="theme-thumb mr-2 mb-2"
                    [class.active]="selectedTheme?.id === theme.id" (click)="selectTheme(theme)">
                    <img [src]="theme.thumbUrl" [alt]="theme.name" class="img-fluid rounded-sm" />
                  </div>
                </div>

                <div class="gift-card" *ngIf="selectedTheme">
                  <div class="card-image">
                    <img [src]="selectedTheme.imageUrl" alt="Gift Card" />
                  </div>

                  <!-- <div class="card-footer-info">
                    <div class="card-name font-weight-bold">
                      {{ cardName }}
                    </div>

                    <div class="barcode-area">
                      <div class="fake-barcode">
                        <span *ngFor="let bar of fakeBars" [class.thick]="bar === 1"></span>
                      </div>
                      <div class="barcode-number">
                        {{ fakeBarcodeText }}
                      </div>
                    </div>

                    <div class="card-right">
                      <div class="amount">RM {{ amount }}</div>
                      <div class="valid">Valid: {{ selectedGiftCard.validityText }}</div>
                    </div>
                  </div> -->
                </div>

              </div>

              <!-- Gift Card Type -->
              <div class="form-group">
                <label class="font-weight-bold">Select Gift Card Type</label>
                <select class="form-control" formControlName="giftCardId" (change)="onGiftCardChange()">
                  <option *ngFor="let gc of activeGiftCards" [value]="gc.id">
                    {{ gc.name }}
                  </option>
                </select>

                <small class="form-text text-muted" *ngIf="selectedGiftCard">
                  Validity: {{ selectedGiftCard.validityText }}
                </small>
              </div>

              <!-- Amount -->
              <div class="form-group">
                <label class="font-weight-bold">Amount</label>
                <select class="form-control" formControlName="amount">
                  <option *ngFor="let amount of amountOptions" [value]="amount">
                    RM {{ amount }}
                  </option>
                </select>

                <small class="form-text text-muted" *ngIf="selectedGiftCard">
                  (RM{{ selectedGiftCard.minAmount }} – RM{{ selectedGiftCard.maxAmount }})
                </small>
              </div>

              <!-- Recipient -->
              <div class="form-group">
                <label class="font-weight-bold">Send Gift Card to</label>
                <input type="email" class="form-control" formControlName="email" placeholder="Email" />
                <div class="text-danger small mt-1" *ngIf="form.get('email')?.invalid && form.get('email')?.touched">
                  Please enter a valid email.
                </div>
              </div>
            </form>
          </div>

          <!-- STEP 2 -->
          <div *ngIf="step === 2" class="p-3 p-md-4 content-area review-screen">

            <div class="review-info mx-auto">
              <div class="mb-4 review-text">
                <div>{{ selectedGiftCard?.name }}</div>
                <div>RM {{ form.value.amount }}</div>
                <div>
                  Valid up to {{ previewExpiryDate }} {{ selectedGiftCard?.validityText ? '(' +
                  selectedGiftCard?.validityText + ')' : '' }}
                </div>
              </div>

              <div class="mb-4 review-text">
                <div>And sending to</div>
                <div class="recipient-email">{{ form.value.email }}</div>
              </div>

              <!-- <div class="review-card-wrap text-center">
                  <img *ngIf="selectedTheme" [src]="selectedTheme.imageUrl" [alt]="selectedTheme.name"
                    class="review-card-image" />
                </div> -->

              <div class="gift-card" *ngIf="selectedTheme">
                <div class="card-image">
                  <img [src]="selectedTheme.imageUrl" alt="Gift Card" />
                </div>

                <!-- <div class="card-footer-info">
                  <div class="card-name card-name font-weight-bold">
                    {{ cardName }}
                  </div>

                  <div class="barcode-area">
                    <div class="fake-barcode">
                      <span *ngFor="let bar of fakeBars" [class.thick]="bar === 1"></span>
                    </div>
                    <div class="barcode-number">
                      {{ fakeBarcodeText }}
                    </div>
                  </div>

                  <div class="card-right">
                    <div class="amount">RM {{ amount }}</div>
                    <div class="valid">Valid: {{ selectedGiftCard.validityText }}</div>
                  </div>
                </div> -->
              </div>

            </div>
          </div>

          <!-- STEP 3 -->
          <div *ngIf="step === 3" class="p-3 p-md-4 content-area background-white">


            <div class="row cursor " *ngFor="let ptype of defaultPaymentTypes;let i=index;">
              <div class="col">
                <div class="row" (click)="onPaymentExpand(ptype,i,ptype.collapsed)"
                  [attr.aria-expanded]="ptype.collapsed" aria-controls="ptype.type">
                  <div class="col">
                    <div class="row m-2 p-2 rounded"
                      [ngClass]="ptype.selected ? 'payment-selected-bg' : 'background-grey'">
                      <div class="col">
                        <div class="row">
                          <div class="col" *ngIf="ptype.type === 'loyalty'">

                            <div class="d-flex justify-content-between align-items-center">
                              <div class="icon-container d-flex">
                                <i class="far icon-loyalty p-4"></i>
                              </div>
                              <label for="{{ptype.name}}" class="cursor mt-2 p-2"
                                [ngClass]="ptype.selected ? 'payment-text-primary' : 'text-dark'">
                                <span class="h6 mt-2 font-weight-bold-500 mt-1">{{ptype.name}}</span>
                              </label>
                            </div>
                          </div>


                          <div class="col" *ngIf="ptype.type === 'fpx'">
                            <div class="d-flex justify-content-between align-items-center">
                              <div class="icon-container d-flex">
                                <i class="far icon-fpx-inline p-4"></i>
                              </div>
                              <label for="{{ptype.name}}" class="cursor mt-2 p-2"
                                [ngClass]="ptype.selected ? 'payment-text-primary' : 'text-dark'">
                                <span class="h6 mt-2 font-weight-bold-500 mt-1">Online Banking</span>
                              </label>
                            </div>
                          </div>
                          <div class="col" *ngIf="ptype.type === 'ewallets'">
                            <div class="d-flex justify-content-between align-items-center">
                              <div class="icon-container d-flex">
                                <i class="far icon-touchandgo-inline p-4"></i>
                                <i class="far icon-grabpay-inline p-4"></i>
                                <i class="far icon-alipay-inline p-4"></i>
                                <i class="far icon-boost-inline p-4"></i>
                              </div>
                              <label for="{{ptype.name}}" class="cursor mt-2 p-2"
                                [ngClass]="ptype.selected ? 'payment-text-primary' : 'text-dark'">
                                <span class="h6 mt-2 font-weight-bold-500 mt-1">{{ptype.name}}</span>
                                <span>{{ptype?.description}}</span>
                              </label>
                            </div>
                          </div>

                          <div class="col" *ngIf="ptype.type === 'card'">

                            <div class="d-flex justify-content-between align-items-center">
                              <div class="icon-container d-flex">
                                <i class="far icon-card-visa-inline p-4"></i>
                                <i class="far icon-card-master-inline p-4"></i>
                              </div>
                              <label for="{{ptype.name}}" class="cursor mt-2 p-2"
                                [ngClass]="ptype.selected ? 'payment-text-primary' : 'text-dark'">
                                <span class="h6 mt-2 font-weight-bold-500 mt-1">{{ptype.name}}</span>
                              </label>
                            </div>

                          </div>
                          <div class="col" *ngIf="ptype.type === 'DuitNow'">

                            <div class="d-flex justify-content-between align-items-center">
                              <div class="icon-container d-flex">
                                <i class="far icon-duitnow-inline p-4"></i>
                              </div>
                              <label for="{{ptype.name}}" class="cursor mt-2 p-2"
                                [ngClass]="ptype.selected ? 'payment-text-primary' : 'text-dark'">
                                <span class="h6 mt-2 font-weight-bold-500 mt-1">{{ptype.name}}</span>
                              </label>
                            </div>
                          </div>
                          <div class="col" *ngIf="ptype.type === 'payatcounter'">

                            <div class="d-flex justify-content-between align-items-center">
                              <div class="icon-container d-flex">
                                <i class="far icon-counterpay-inline p-4"></i>
                              </div>
                              <label for="{{ptype.name}}" class="cursor mt-2 p-2"
                                [ngClass]="ptype.selected ? 'payment-text-primary' : 'text-dark'">
                                <span class="h6 mt-2 font-weight-bold-500 mt-1">{{ptype.name}}</span>
                              </label>
                            </div>
                          </div>
                          <div class="col-1">
                            <label *ngIf="ptype.showicon" class="m-0 float-right p-2 pt-08 pr-2 cursor"
                              [ngClass]="ptype.selected ? 'payment-text-primary' : 'text-dark'">
                              <i class="fas fa-chevron-down float-right" *ngIf="ptype.collapsed"></i>
                              <i class="fas fa-chevron-up float-right" *ngIf="!ptype.collapsed"></i>
                            </label>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col">
                            <span *ngIf="ptype.option_selected"
                              [ngClass]="ptype.option_selected ? 'payment-text-primary' : 'text-dark'">
                              <span *ngIf="ptype.type !== 'payatcounter'">{{ptype.selected}} Selected</span>
                              <span *ngIf="ptype.type === 'payatcounter'">
                                <span *ngIf="!chargetoRoom">{{ptype.selected}} Selected</span>
                                <span *ngIf="chargetoRoom">Charge to my room Selected</span>
                              </span>
                            </span>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
                <div id="{{ptype.type}}" [collapse]="ptype.collapsed" [isAnimated]="true" class="container">

                  <div class="row align-items-center payment-option-row" [class.is-selected]="option.selected" *ngFor="let option of ptype.list;let j=index;">
                    <div class="col-1 mt-1 cursor">
                      <div class="round">
                        <input [checked]="option.selected" name="{{option.value}}" type="checkbox"
                          id="{{option.value}}{{j}}" (change)="onPaymentTypeSelect($event, ptype, option, i, j)" />
                        <label class="cursor" for="{{option.value}}{{j}}"></label>
                      </div>
                    </div>
                    <div class="col">
                      <label for="{{option.value}}{{j}}" class="pl-2 text-dark cursor">
                        {{option.text}}
                      </label>
                      <span class="pl-2 text-primary fa-xs-small-70 description"
                        [innerHTML]="option.description ? option.description : ''"></span>
                      <span class="text-primary fa-xs-small-70 description text-center"
                        [innerHTML]="option.subDescription ? option.subDescription : ''"></span>
                    </div>
                  </div>



                </div>
              </div>
            </div>
          </div>

          <!-- Footer -->
          <div class="footer-bar d-flex justify-content-center align-items-center">
            <!-- step 1 -->

            <div *ngIf="step === 1" class="d-flex w-100 footer-actions" [ngClass]="{
    'justify-content-between': showBackButton,
    'justify-content-center': !showBackButton
  }">
              <button *ngIf="showBackButton" type="button" class="btn btn-outline-secondary action-btn-light"
                (click)="goBack()">
                Back
              </button>

              <button type="button" class="btn btn-dark action-btn" [disabled]="form.invalid" (click)="goToReview()">
                Next
              </button>
            </div>

            <!-- step 2 -->
            <div *ngIf="step === 2" class="d-flex justify-content-between w-100 footer-actions">
              <button type="button" class="btn btn-outline-secondary action-btn-light" (click)="backToForm()">
                Back
              </button>

              <button type="button" class="btn btn-dark action-btn" (click)="proceedToPay()">
                Proceed to Pay
              </button>
            </div>

            <!-- step 3 -->
            <button *ngIf="step === 3" type="button" class="btn btn-dark action-btn" (click)="checkPayment()">
              {{ isPaying ? 'Processing...' : 'Pay Now' }}
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>


<!-- </app-drawer> -->

<app-loading-component></app-loading-component>

<ng-template #customerDetails>
  <div class="modal-body modal-styles rounded" [formGroup]="customerDetailsForm">

    <!-- Header -->
    <div class="row align-items-center">
      <div class="col text-center">
        <label class="text-gray">
          To Process <span class="text-primary">FPX</span> payment, please provide the following
        </label>
      </div>
      <div class="col-auto">
        <button type="button" class="close close-button text-dark" data-dismiss="modal" aria-label="Close"
          (click)="onCustomerDetailCloseClick()" style="margin-top: -10px;">
          <span aria-hidden="true" style="font-size: 40px;">&times;</span>
        </button>
      </div>
    </div>

    <!-- Name input -->
    <div class="form-group">
      <input type="text" maxlength="50" formControlName="name" class="form-control" placeholder="Name"
        [ngClass]="{'has-error': ((customerDetailsForm.get('name').touched || customerDetailsForm.get('name').dirty) && customerDetailsForm.get('name').errors)}" />
    </div>

    <!-- Email input -->
    <div class="form-group">
      <input type="text" maxlength="60" formControlName="email" class="form-control" placeholder="Email"
        [ngClass]="{'has-error': ((customerDetailsForm.get('email').touched || customerDetailsForm.get('email').dirty) && customerDetailsForm.get('email').errors)}" />
    </div>

    <!-- Phone input -->
    <div class="form-group tel-wrapper">
      <ngx-intl-tel-input [cssClass]="'form-control'" [preferredCountries]="preferredCountries"
        [enableAutoCountrySelect]="false" [enablePlaceholder]="true" [searchCountryFlag]="true"
        [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]" [selectFirstCountry]="false"
        [selectedCountryISO]="selectedCountryISO" [maxLength]="15" [phoneValidation]="true"
        [separateDialCode]="separateDialCode" name="mobile" formControlName="contact"
        [ngClass]="{'has-error': ((customerDetailsForm.get('contact').touched || customerDetailsForm.get('contact').dirty) && customerDetailsForm.get('contact').errors)}">
      </ngx-intl-tel-input>
    </div>

    <!-- Submit button -->
    <div class="form-group text-right">
      <button type="button" class="btn btn-outline-secondary bg-dark text-white"
        (click)="onCustomerNextClick()">Next</button>
    </div>

  </div>
</ng-template>


<ng-template #qrPayment>

  <div class="modal-body inquiry-styles">

    <!-- <div class="row">
      <div class="col text-center">

      </div>
      <div class="col-1">
        <i class="fas fa-times fa-lg cursor close" (click)="showConfirmCloseQrPayment()"></i>
      </div>
    </div> -->
    <ng-container *ngIf="qrImageSrc">
      <div class="d-flex justify-content-center align-items-center">
        <div class="text-center text-danger font-weight-bold">
          <h5>Countdown: {{ displayTime }}</h5>
        </div>
      </div>


      <div *ngIf="displayTime !== '00:00'" class="h6 d-flex justify-content-center align-items-center">
        <div class="text-center font-weight-bold">
          <img [src]="qrImageSrc" alt="QR Code" style="width: 180px; height: auto;" />

        </div>
      </div>

      <div *ngIf="displayTime === '00:00'" class="h6 d-flex justify-content-center align-items-center">
        <div class="text-center font-weight-bold">
          <span>{{bankResult}}</span>
          <p>{{inquiryMessage}}</p>

        </div>
      </div>

      <div *ngIf="displayTime === '00:00'" class="d-flex flex-column justify-content-center align-items-center"
        style="gap: 10px;">

        <button class="btn btn-primary w-100" style="max-width: 300px;background-color: #0988b5; border-radius:10px"
          (click)="onPaymentCloseClick()">
          Try again or Select another payment method
        </button>

        <button class="btn w-100" style="max-width: 200px;
    border-radius: 34px;
    background-color: #b2afaf;
    color: black;" (click)="onPaymentCloseClick()">
          Cancel
        </button>

      </div>




      <div *ngIf="displayTime !== '00:00'" class="d-flex flex-column justify-content-center align-items-center">
        <span>For quick result please follow step</span>
        <span>a) Screenshot the QR and save to your photos</span>
        <span>b) Open Bank app, scan, select <b>scan from gallery</b></span>
      </div>


      <div *ngIf="displayTime !== '00:00'" class="d-flex justify-content-center mb-2">
        <div class="spinner-border text-blue" role="status">
          <span class="visually-hidden"></span>
        </div>
      </div>
      <div *ngIf="displayTime !== '00:00'" class="h6 d-flex justify-content-center align-items-center">
        <div class="text-center font-weight-bold">
          <p [ngClass]="inquiryCount === 0 ? 'text-primary' : 'text-warning'">
            {{inquiryMessage}}
          </p>
        </div>
      </div>

      <div *ngIf="displayTime !== '00:00'" class="h6 d-flex justify-content-center align-items-center">
        <div class="text-center font-weight-bold">
          <p style="color: red;">
            DO NOT CLOSE THIS PAGE ONCE FINISHED MAKING PAYMENT,
            OPEN THE PAGE AGAIN AND ACKNOWLEDGE ORDER TICKET
          </p>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!qrImageSrc">
      <div class="row">
        <div class="col text-center">

        </div>
        <div class="col-1">
          <i class="fas fa-times fa-lg cursor close" (click)="onPaymentCloseClick()"></i>
        </div>
      </div>
      <div *ngIf="displayTime !== '00:00'" class="h6 d-flex justify-content-center align-items-center">
        <div class="text-center font-weight-bold">

          <span>Could not connect to DuitNow. Please try again later!</span>
        </div>
      </div>
    </ng-container>

    <div *ngIf="isManual" class="d-flex justify-content-center mb-2">
      <div class="spinner-border text-blue" role="status">
        <span class="visually-hidden"></span>
      </div>
    </div>
    <div *ngIf="isManual" class="h6 d-flex justify-content-center align-items-center">
      <div class="text-center font-weight-bold">
        <p [ngClass]="inquiryCount === 0 ? 'text-primary' : 'text-warning'">
          {{inquiryMessage}}
        </p>
      </div>
    </div>


    <!-- <div *ngIf="displayTime === '00:00'" class="mt-3 d-flex flex-column justify-content-center align-items-center"
      style="gap: 10px;">

      <button class="btn btn-danger w-100" style="max-width: 300px;" (click)="manualInquiryQr()">Check status

      </button>

    </div> -->


  </div>
</ng-template>

<ng-template #paymentfailure>
  <!-- <div class="modal-header">
    <span class="font-weight-bold">Payment Failed</span>
    <i class="fas fa-times fa-lg cursor close" (click)="onCloseClick()"></i>
  </div>
  <div class="modal-body rounded">
    <div class="row border-bottom">
      <div class="col text-center">
        We could not process your payment due to {{paymentError}}.<br>
        Your order details have been saved in your cart.
      </div>
    </div>
  </div> -->


  <div class="modal-body inquiry-styles">

    <div class="row">
      <div class="col text-center">

      </div>
      <div class="col-1">
        <i *ngIf="!isLoading" class="fas fa-times fa-lg cursor close" (click)="onCloseClick()"></i>
      </div>
    </div>
    <div *ngIf="isLoading" class="d-flex justify-content-center mb-2">
      <div class="spinner-border text-blue" role="status">
        <span class="visually-hidden"></span>
      </div>
    </div>
    <div *ngIf="isLoading " class="h6 d-flex justify-content-center align-items-center">
      <div class="text-center font-weight-bold">
        <p>We are in process of getting response from the bank</p>
        <p>Please hold...</p>
      </div>
    </div>
    <div *ngIf="!isLoading && paymentDone" class="h6 d-flex justify-content-center align-items-center">
      <div class="text-center font-weight-bold">
        <p>We have got the response your payment is successful</p>
      </div>
    </div>

    <div *ngIf="!isLoading && !paymentDone" class="h6 d-flex justify-content-center align-items-center">
      <div class="text-center font-weight-bold">
        <p>We have got the response: {{paymentResponse}}</p>

      </div>
    </div>

  </div>
</ng-template>